<template>
  <v-container class="reset-password">
    <!-- META-DATA -->
    <vue-headful
      :title="'Reset Password' + this.$store.state.app.meta.titleSuffix"
      :description="null" />

    <div
      v-if="loadingVerify"
      class="verify-loader">
      <v-progress-circular
        size="100"
        indeterminate
        color="primary" />
      <h3>verifying email address...</h3>
    </div>

    <v-form
      v-if="!loadingVerify"
      ref="resetPassword"
      v-model="valid"
      class="reset-password-form">
      <div class="reset-password-form__header">
        <h2>enter new password for {{ email }}</h2>
      </div>

      <v-text-field
        v-if="!success"
        ref="password"
        v-model="password"
        label="New Password"
        :rules="[
          v => !!v || 'This field is required',
          v => v.length >= 8 || 'Minimum password length is 8 characters',
          v => !!v.match(/[^\s\w]/g) || 'Password must include at least one special character',
          v => !!v.match(/[\d]/g) || 'Password must include at least one number',
          v => !!v.match(/[A-Z]/g) || 'Password must include an uppercase letter',
          v => !!v.match(/[a-z]/g) || 'Password must include a lowercase letter',
        ]"
        :append-icon="showPassword ? 'visibility_off' : 'visibility'"
        :type="showPassword ? 'text' : 'password'"
        class="reset-password-form__new-password"
        required
        @click:append="showPassword = !showPassword" />
      <v-text-field
        v-if="!success"
        ref="confirmPassword"
        label="Confirm New Password"
        :rules="[
          v => !!v || 'This field is required',
          v => v === password || 'Passwords must match'
        ]"
        :type="showPassword ? 'text' : 'password'"
        class="reset-password-form__confirm-password"
        required />

      <span
        v-if="!success"
        class="reset-password-form__password-hint">
        Your new password must be at least 8 characters long, and must include:
        <ul>
          <li>one uppercase letter</li>
          <li>one lowercase letter</li>
          <li>one number</li>
          <li>one special character</li>
        </ul>
      </span>

      <v-btn
        v-if="!success"
        :disabled="!valid"
        :loading="loading"
        color="primary"
        large
        class="create-account-button"
        @click="resetPassword">
        submit
      </v-btn>

      <div
        v-if="success"
        class="success-message">
        <h3 class="success-message__header">Password Reset Successfully</h3>
        <p>
          You can now log in using your new password.
        </p>
        <v-btn
          :to="{ name: 'login' }"
          color="primary">
          go to log in
        </v-btn>
      </div>
    </v-form>
  </v-container>
</template>

<script>
import api from '../../utils/api';

export default {
  name: 'ResetPassword',
  data() {
    return {
      showPassword: false,
      password: '',
      email: '',

      valid: false,
      loading: false,
      success: false,
      loadingVerify: true,
    };
  },
  created() {
    this.loadingVerify = true;
    const { token } = this.$route.params;
    if (token) {
      api
        .getData(`/auth/reset_password/${token}`)
        .then((res) => {
          this.email = res.data.email;
          this.loadingVerify = false;
        })
        .catch(() => {
          this.$router.replace('/404');
        });
    } else {
      this.$router.replace('/404');
    }
  },
  methods: {
    resetPassword() {
      this.loading = true;
      const { token } = this.$route.params;
      // submit new password to server
      const requestData = {
        password: this.password,
        token,
      };
      api
        .postData('/auth/reset_password', requestData)
        .then(() => {
          this.loading = false;
          this.success = true;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
@require('../../stylus/base')

.reset-password-form
  &__password-hint
    font-size: $font-size--small
    color: $accent--dark

</style>
